export default __webpack_public_path__ + "static/media/cart-in.c87a5cae.svg";